import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  sendByEmailController: [
    'runtimeConstant',
    '$scope',
    '$anchorScroll',
    '$filter',
    'revision',
    'emailService',
    'authService',
    function (
      runtimeConstant,
      $scope,
      $anchorScroll,
      $filter,
      revision,
      emailService,
      authService
    ) {
      'use strict';

      function AddEmail() {
        let row = 0;

        const lastIndex = $scope.data.length - 1;
        if (lastIndex >= 0) {
          const lastValue = $scope.data[lastIndex];
          $anchorScroll(`${lastValue.row}`);
          row = lastValue.row + 1;
        }

        $scope.data.push({ row: row, isValid: true, email: '' });
      }

      function DeleteEmail(row) {
        const index = $scope.data.findIndex((item) => item.row === row);
        if (index !== -1) {
          $scope.data.splice(index, 1);
        }
      }

      function IsValidEmail(email) {
        var regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(email);
      }

      function SendEmails() {
        let allValid = true;

        $scope.data.forEach((item) => {
          item.isValid = item.email && IsValidEmail(item.email);

          if (!item.isValid) {
            allValid = false;
          }
        });

        if (!allValid) return;

        var emails = $scope.data.map(function (item) {
          return item.email;
        });

        if ($scope.option.receiveCopy) {
          emails.push(authService.user.email);
        }

        emailService
          .send(revision.id, emails)
          .then(function () {
            swal.fire({
              title: 'Documento enviado',
              text: 'O documento foi enviado para o(s) destinatário(s) informado(s) através do e-mail digitaldocbr@digitaldoc.com.br',
              icon: 'success',
              showConfirmButton: true,
              allowEscapeKey: false,
              allowOutsideClick: false,
            });

            $scope.$close();
          })
          .catch(function (err) {
            swal.fire(
              err + '!\n' + $filter('translate')('AN ERROR OCCURRED'),
              $filter('translate')('SEND BY EMAIL ERROR'),
              'error'
            );
          });
      }

      function onCloseClick() {
        $scope.$close();
      }

      function onCancelClick() {
        $scope.$close();
      }

      function onSendClick() {
        SendEmails();
      }

      function onAddEmailClick() {
        AddEmail();
      }

      function onDeleteEmailClick(row) {
        DeleteEmail(row);
      }

      function run() {
        try {
          $scope.option = { receiveCopy: true };
          $scope.data = [{ row: 0, isValid: true, email: '' }];
          $scope.onCloseClick = logWrapper(
            onCloseClick,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.onCancelClick = logWrapper(
            onCancelClick,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.onSendClick = logWrapper(
            onSendClick,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.onAddEmailClick = logWrapper(
            onAddEmailClick,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.onDeleteEmailClick = logWrapper(
            onDeleteEmailClick,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
